module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('scroll', {
    staticClass: "bg-white",
    on: {
      "refresh": _vm.refresh
    }
  }, [_c('div', {
    staticClass: "doctor-info"
  }, [_c('div', {
    staticClass: "head doc-header",
    style: ({
      backgroundImage: 'url(' + _vm.doctUrl + ')'
    }),
    attrs: {
      "id": "doct-header"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('p', {
    staticClass: "f-large ellipsis"
  }, [_vm._v(_vm._s(_vm.doctInfo.doctLevel) + " " + _vm._s(_vm.doctInfo.doctName))]), _vm._v(" "), _c('p', {
    staticClass: "f-minor ellipsis",
    staticStyle: {
      "margin-top": "0.15rem"
    }
  }, [_vm._v(_vm._s(_vm.doctInfo.deptName))])])]), _vm._v(" "), _c('div', {
    staticClass: "docinfo-desc row"
  }, [_vm._v("\n            " + _vm._s(_vm.desc) + "\n        ")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11b73509","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/doctinfo/DoctInfo.vue
// module id = 787
// module chunks = 0